import { Button, Theme, Typography } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { Stack, useMediaQuery } from '@mui/system';
import { FormattedMessage } from 'react-intl';
import { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { useDrawerContext } from '../drawer/DrawerContext';
import { useJourneyFilters } from './useJourneyFilters';

const JourneyFiltersButton: FC = () => {
	const theme = useTheme();
	const { setDrawer } = useDrawerContext();
	const [filters] = useJourneyFilters();
	const matchUpSM = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

	const filtersCount = Object.entries(filters).reduce((count, [filterKey, filterValue]) => {
		if (filterKey === 'duration' && filterValue === '-') {
			return count;
		}
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		return filterValue != null ? count + 1 : count;
	}, 0);

	const handleClick = () => {
		setDrawer('journeyFilter', {});
	};

	return (
		<Button
			onClick={handleClick}
			sx={!matchUpSM ? { '.MuiButton-startIcon': { margin: 0, svg: { height: '18px' } }, p: 1, minWidth: 0 } : {}}
			startIcon={<FilterList sx={!matchUpSM ? { width: 18 } : {}} />}
			endIcon={
				filtersCount > 0 && (
					<Stack
						justifyContent={'center'}
						alignItems={'center'}
						fontSize={8}
						color={'#fff'}
						bgcolor={theme.palette.primary.main}
						borderRadius={'100%'}
						p={1}
						minWidth={10}
						maxHeight={22}
					>
						<Typography fontSize={'small'}>{filtersCount}</Typography>
					</Stack>
				)
			}
			variant={'outlined'}
		>
			{matchUpSM && <FormattedMessage id={'journey.view.header.filter'} />}
		</Button>
	);
};

export { JourneyFiltersButton };
